import React from 'react';
import './styles/background.scss';

export const Background = () => {
  return (
    <>

      <div className='gradientBG'></div>
    </>
  );
};
